import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiURL } from '../Util/apiURL';
import { formatDateFromDateInput, formatDateFromtoLocaleDateString } from '../Util/get-date';

const filterById = (values, selectedValueId) => {
  const filterdValue = values.filter((item) => Number(item.id) === Number(selectedValueId));
  return filterdValue[0];
};

const date = new Date();
const dateOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const apiHOST = apiURL();
const initialState = {
  cpc: {},
  monto: '',
  fecha: date.toString(),
  fechaDisplay: formatDateFromtoLocaleDateString(String(date.toLocaleDateString())),
  divisa: {},
  tipoDeCambio: 1,
  observaciones: '',
  folio: '',
  motivo: '',
  closeModal: false,
};

export const insertNotaCreditoCliente = createAsyncThunk(
  'crearNotaCreditoCliente/insertNotaCreditoCliente',
  async (payload) => {
    const { request, history } = payload;

    try {
      console.log('Reques INSERT PAGO PROVEEDORt---->');
      console.log(request);
      const updatedRequest = { ...request };
      updatedRequest.fecha = new Date(request.fecha);
      console.log(updatedRequest);

      const response = await axios.post(`${apiHOST}notas-de-credito-cliente`, updatedRequest);

      return;
    } catch (err) {
      // return err;
    }
  },
);

const createNotaCreditoClienteSlice = createSlice({
  name: 'createNotaCreditoCliente',
  initialState: initialState,
  reducers: {
    change(state, action) {
      switch (action.payload.field) {
        case 'monto':
          console.log('Number(action.payload.value)');
          console.log('Number(action.payload.value)');
          console.log(Number(action.payload.value));
          state.monto = Number(action.payload.value);

          break;
        case 'folio':
          state.folio = action.payload.value;

          break;
        case 'motivo':
          state.motivo = action.payload.value;

          break;
        case 'observaciones':
          state.observaciones = action.payload.value;

          break;
        case 'fecha':
          state.fecha = new Date(action.payload.value);
          state.fechaDisplay = formatDateFromDateInput(action.payload.value);
          break;

        case 'tipoDeCambio':
          if (action.payload.value > 0) {
            state.tipoDeCambio = Number(action.payload.value);
            state.monto = '';
          }

          break;
        default:
      }
    },
    asign(state, action) {
      state[action.payload.reduxStateTree] = filterById(
        action.payload.valuesToFilter,
        action.payload.selectedValue,
      );
    },
    setCpp(state, action) {
      console.log(' setCpp     action.payload');
      console.log(action.payload);
      state.cpc = action.payload;
    },
    resetMonto(state) {
      state.monto = '';
    },
    resetCloseModal(state) {
      state.closeModal = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(insertNotaCreditoCliente.fulfilled, (state, action) => {
      state.monto = '';
      state.folio = '';
      state.closeModal = true;
    });
  },
});

export default createNotaCreditoClienteSlice;

export const createNotaCreditoClienteActions = createNotaCreditoClienteSlice.actions;
